export type MailAddress = string | { address?: string; name?: string };

export function formatMailAddresses(addresses: MailAddress[] | null | undefined): string {
  return (addresses ?? [])
    .map((item) => {
      if (typeof item === "string") return item;
      if (item.name && item.address) return `${item.name} <${item.address}>`;
      return item.address || item.name || "";
    })
    .filter(Boolean)
    .join(", ");
}
